import SectionModel from "../../models/sectionModel.js";
import {
    CONTROL_TYPE, LOYALTY_LEVEL, loyaltyLevels,
    MARKETPLACE_SETTINGS_MODEL,
    MODEL_CONTROL_TYPE,
    MODEL_TYPE, TYPE_ACTION,
} from "../../utils/enums.js";
import {
    LOYALTY_SETTINGS_ADVANCED_CASHBACK, LOYALTY_SETTINGS_CASH_OUT,
    LOYALTY_SETTINGS_CASHBACK, LOYALTY_SETTINGS_GET,
    LOYALTY_SETTINGS_REGISTER_VOUCHER,
} from "../../store/reducers/restaurant/restaurant-actions.js";
import {createControlModel} from "../controlModelFactory.js";
import {isMobileWidth} from "../restaurant.js";
import {createBreadcrumbModel} from "../createBreadcrumbModel.js";
import {getInitModel} from "../initModels.js";
import FilterOptionsModel from "../../models/filterOptionsModel.js";
import {getDeliveryTypeName, getDeliveryTypes} from "../../utils/constants.js";
import i18n from "i18next";

export function createLoyaltySettingsAdvancedCashbackSectionModel({ ...args }) {
    return new SectionModel({
        filterOptions: createLoyaltySettingsAdvancedCashbackFilter(),
        columns: [
            {
                title: 'settings.loyaltyCashback.SPEND_BONUS_PERCENT',
                accessor: 'spendBonusPercent',
            },
            {
                title: 'settings.loyaltyCashback.LOYALTY_LEVEL',
                accessor: 'loyaltyLevel',
                component: item => LOYALTY_LEVEL[item.loyaltyLevel],
            },
            {
                title: 'settings.loyaltyCashback.DELIVERY_TYPE',
                accessor: 'deliveryType',
                component: item => getDeliveryTypeName(item.deliveryType),
            },
            {
                title: 'basic.EDIT_BUTTON',
                type: CONTROL_TYPE.link,
                link: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashbackEdit,
                iconName: 'editItem',
                width: '150px',
                tooltipText: i18n.t('basic.EDIT_BUTTON'),
            }
        ],
        actionName: LOYALTY_SETTINGS_ADVANCED_CASHBACK,
        actionLoad: LOYALTY_SETTINGS_GET,
        hideCellForSort: true,
        isForceUpdate: true,
        isHideControls: true,
        initNewItemModel: item => item,
        typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashback,
        controls: [
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
                isShow: isMobileWidth,
            }),
            createControlModel({
                type: MODEL_CONTROL_TYPE.add,
                url: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashbackNew,
            }),
        ],
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'header.menu.MARKETPLACE_SETTINGS',
            }),
            createBreadcrumbModel({
                label: "settings.marketplaceMessage.LOYALTY",
            }),
        ],
        label: 'settings.loyaltyCashback.ADVANCED_CASHBACK',
        tabs: [
            {
                title: "settings.loyaltyCashback.MENU_LABEL",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashback,
                search: () => '',
            },
            {
                title: "settings.loyaltyCashback.ADVANCED_CASHBACK",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashback,
                search: () => '',
            },
            {
                title: "settings.loyaltyCashback.CASH_OUT",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOut,
                search: () => '',
            },
        ],
        mappingLambda: state => {
            return (state.restaurant.data && state?.restaurant?.data?.loyaltySettings?.advancedCashbackSettings) || [];
        },
    });
}

export function createLoyaltySettingsAdvancedCashbackEditSectionModel({ ...args }) {
    return new SectionModel({
        columns: [
            {
                title: 'settings.loyaltyCashback.LOYALTY_LEVEL',
                accessor: 'loyaltyLevel',
                isEditable: true,
                type: CONTROL_TYPE.select,
                values: loyaltyLevels(),
            },
            {
                title: 'settings.loyaltyCashback.SPEND_BONUS_PERCENT',
                accessor: 'spendBonusPercent',
                isEditable: true,
                max: item => 100,
                min: item => 0,
                isItemValid: item => item && item.spendBonusPercent <= 100 && item.spendBonusPercent >= 0,
                useColorRed: item => !(item.spendBonusPercent <= 100 && item.spendBonusPercent >= 0),
                measure: '%',
                type: CONTROL_TYPE.number,
            },
            {
                title: 'settings.loyaltyCashback.DELIVERY_TYPE',
                accessor: 'deliveryType',
                isEditable: true,
                type: CONTROL_TYPE.select,
                values: getDeliveryTypes()
            },
        ],
        parentUrl: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashback,
        actionName: LOYALTY_SETTINGS_ADVANCED_CASHBACK,
        actionLoad: LOYALTY_SETTINGS_GET,
        typeAction: args.typeAction,
        initNewItemModel: item => getInitModel(MODEL_TYPE.advancedCashBackEditModel, item),
        typeModel: args.typeAction === TYPE_ACTION.new
            ? MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashbackNew
            : MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashbackEdit,
        controls: [
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
            }),
        ],
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'header.menu.MARKETPLACE_SETTINGS',
            }),
            createBreadcrumbModel({
                label: "settings.marketplaceMessage.LOYALTY",
            }),
        ],
        label: 'settings.loyaltyCashback.ADVANCED_CASHBACK',
        mappingLambda: state => {
            return (state.restaurant.data && state?.restaurant?.data?.loyaltySettings?.advancedCashbackSettings) || [];
        },
    });
}

export function createLoyaltySettingsCashbackSectionModel({ ...args }) {
    return new SectionModel({
        columns: [
            {
                title: 'settings.loyaltyCashback.CASHBACK',
                accessor: 'spendBonusPercent',
                isEditable: true,
                type: CONTROL_TYPE.number,
                max: () => 100,
                isItemValid: item => item.spendBonusPercent >= 0 && item.spendBonusPercent <= 100,
                useColorRed: item => !(item.spendBonusPercent >= 0 && item.spendBonusPercent <= 100),
                measure: '%'
            },
            {
                title: 'settings.loyaltyCashback.TARGET',
                accessor: 'accumulatedBonusTarget',
                isEditable: true,
                type: CONTROL_TYPE.number,
                isInline: true,
            },
        ],
        actionName: LOYALTY_SETTINGS_CASHBACK,
        actionLoad: LOYALTY_SETTINGS_GET,
        initNewItemModel: item => item,
        typeAction: args.typeAction,
        stayAfterSave: true,
        typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashback,
        controls: [
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
                isShow: isMobileWidth,
            }),
        ],
        saveControlsConfig: {
            cancel: { title: "basic.RESET_BUTTON", action: ()=> {}, isInit: true }
        },
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'header.menu.MARKETPLACE_SETTINGS',
            }),
            createBreadcrumbModel({
                label: "settings.marketplaceMessage.LOYALTY",
            }),
        ],
        label: 'settings.loyaltyCashback.MENU_LABEL',
        tabs: [
            {
                title: "settings.loyaltyCashback.MENU_LABEL",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashback,
                search: () => '',
            },
            {
                title: "settings.loyaltyCashback.ADVANCED_CASHBACK",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashback,
                search: () => '',
            },
            {
                title: "settings.loyaltyCashback.CASH_OUT",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOut,
                search: () => '',
            },
        ],
        mappingLambda: state => {
            const settings = (state.restaurant.data && state.restaurant.data.loyaltySettings) || {};
            return {...settings, spendBonusPercent: parseFloat(((settings.spendBonusPercent || 0) * 100).toFixed(2))}
        },
    });
}

export function createLoyaltySettingsRegisterBonusSectionModel({ ...args }) {
    return new SectionModel({
        columns: [
            {
                title: '',
                accessor: 'bonus_info',
                isEditable: true,
                isFillContent: true,
                isItemValid: item => {
                    if(!item.bonus_info) return true;

                    const percent = item?.bonus_info?.checkout_limit_percent;
                    const bonus = item?.bonus_info?.bonus;
                    const isNameExist = item?.bonus_info?.bonus_name;
                    const isValidPercent = percent >= 0.01 && percent <= 1.0;
                    const isValidValidityPeriod = item?.bonus_info?.bonus_expiration !== '00:00:00';
                    return isValidPercent && isValidValidityPeriod && isNameExist && bonus;
                },
                zeroValueIsOff: false,
                disable: () => false,
                type: CONTROL_TYPE.bonusVoucher,
            },
        ],
        actionName: LOYALTY_SETTINGS_REGISTER_VOUCHER,
        actionLoad: LOYALTY_SETTINGS_GET,
        initNewItemModel: item => ({ bonus_info: getInitModel(MODEL_TYPE.loyaltyRegisterVoucher, item) }),
        typeAction: args.typeAction,
        stayAfterSave: true,
        typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashback,
        controls: [
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
                isShow: isMobileWidth,
            }),
        ],
        saveControlsConfig: {
            cancel: { title: "basic.RESET_BUTTON", action: ()=> {}, isInit: true }
        },
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'header.menu.MARKETPLACE_SETTINGS',
            }),
            createBreadcrumbModel({
                label: "settings.marketplaceMessage.LOYALTY",
            }),
        ],
        label: 'settings.loyaltyRegisterBonus.LABEL',
        mappingLambda: state => {
            const settings =  state.restaurant.data && state.restaurant.data.loyaltySettings;
            return settings || {};
        },
    });
}




export function createLoyaltySettingsCashOutSectionModel({ ...args }) {
    return new SectionModel({
        filterOptions: createLoyaltySettingsAdvancedCashbackFilter(),
        columns: [
            {
                title: 'settings.loyaltyCashback.ACCUMULATED_BONUS_TARGET',
                accessor: 'accumulatedBonusTarget',
            },
            {
                title: 'settings.loyaltyCashback.LOYALTY_LEVEL',
                accessor: 'loyaltyLevel',
                component: item => LOYALTY_LEVEL[item.loyaltyLevel],
            },
            {
                title: 'basic.EDIT_BUTTON',
                type: CONTROL_TYPE.link,
                link: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOutEdit,
                iconName: 'editItem',
                width: '150px',
                tooltipText: i18n.t('basic.EDIT_BUTTON'),
            }
        ],
        actionName: LOYALTY_SETTINGS_CASH_OUT,
        actionLoad: LOYALTY_SETTINGS_GET,
        hideCellForSort: true,
        isForceUpdate: true,
        isHideControls: true,
        initNewItemModel: item => item,
        typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOut,
        controls: [
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
                isShow: isMobileWidth,
            }),
            createControlModel({
                type: MODEL_CONTROL_TYPE.add,
                url: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOutNew,
            }),
        ],
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'header.menu.MARKETPLACE_SETTINGS',
            }),
            createBreadcrumbModel({
                label: "settings.marketplaceMessage.LOYALTY",
            }),
        ],
        label: 'settings.loyaltyCashback.CASH_OUT',
        tabs: [
            {
                title: "settings.loyaltyCashback.MENU_LABEL",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashback,
                search: () => '',
            },
            {
                title: "settings.loyaltyCashback.ADVANCED_CASHBACK",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsAdvancedCashback,
                search: () => '',
            },
            {
                title: "settings.loyaltyCashback.CASH_OUT",
                typeModel: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOut,
                search: () => '',
            },
        ],
        mappingLambda: state => {
            return (state.restaurant.data && state?.restaurant?.data?.loyaltySettings?.cashoutSettings) || [];
        },
    });
}

export function createLoyaltySettingsCashOutEditSectionModel({ ...args }) {
    return new SectionModel({
        columns: [
            {
                title: 'settings.loyaltyCashback.LOYALTY_LEVEL',
                accessor: 'loyaltyLevel',
                isEditable: true,
                type: CONTROL_TYPE.select,
                values: loyaltyLevels(),
            },
            {
                title: 'settings.loyaltyCashback.ACCUMULATED_BONUS_TARGET',
                accessor: 'accumulatedBonusTarget',
                isEditable: true,
                type: CONTROL_TYPE.number,
            },
        ],
        parentUrl: MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOut,
        actionName: LOYALTY_SETTINGS_CASH_OUT,
        actionLoad: LOYALTY_SETTINGS_GET,
        typeAction: args.typeAction,
        initNewItemModel: item => getInitModel(MODEL_TYPE.cashOutEditModel, item),
        typeModel: args.typeAction === TYPE_ACTION.new
            ? MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOutNew
            : MARKETPLACE_SETTINGS_MODEL.loyaltySettingsCashOutEdit,
        controls: [
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
            }),
        ],
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'header.menu.MARKETPLACE_SETTINGS',
            }),
            createBreadcrumbModel({
                label: "settings.marketplaceMessage.LOYALTY",
            }),
        ],
        label: 'settings.loyaltyCashback.CASH_OUT',
        mappingLambda: state => {
            return (state.restaurant.data && state?.restaurant?.data?.loyaltySettings?.cashoutSettings) || [];
        },
    });
}


function createLoyaltySettingsAdvancedCashbackFilter() {
    let filterOptionsModel = new FilterOptionsModel();

    // filterOptionsModel.addOptions('search', CONTROL_TYPE.text, null, function(translations) {
    //     return translationsFilter(this.selected, translations);
    // });

    return filterOptionsModel;

}